<template>
  <div class="flex-1 cursor-auto">
    <div class="inline cursor-pointer">
      <icon-base
        :data-cy="'offer-shared-icon-' + icon"
        :icon="icon"
        :class="htmlClass"
        @click.stop="togleOfferShared"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import type { IOffer } from "@/models/funders";

const { offerDetails } = defineProps<{
  offerDetails: IOffer;
}>();

const { dispatch } = useStore();

const icon = computed(() =>
  offerDetails.is_shared ? "show-pass-no-bg" : "show-pass"
);
const htmlClass = computed(() =>
  offerDetails.is_shared ? "text-gray-500" : "text-disabled-medium"
);

const togleOfferShared = async () => {
  await dispatch("applications/toggleShowOffer", offerDetails.id);
};
</script>
